import { useMutation } from "react-query";
import {
  BASE_URL_REQUEST_PASSWORD,
  createNewRequestPasswordAxios,
  resetPasswordUserAxios,
} from "../services/userAdminAPI";
import { CallbackFunction } from "../../../common/types/callback.types";
import { AxiosError } from "axios";
import { ChangePasswordRequest } from "../types/user.types";
import { useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import useQueryURL from "../../../common/hooks/useQueryURL";

export const useChangeUserPasswordRequest = () => {
  const createChangeUserPassword = useMutation({
    mutationFn: ({
      email,
      callback,
    }: {
      email: string;
      callback?: CallbackFunction<ChangePasswordRequest, AxiosError>;
    }) => {
      return createNewRequestPasswordAxios(email)
        .then((response) => {
          callback && callback({ result: response });
          return Promise.resolve(response);
        })
        .catch((error) => {
          callback && callback({ error: error });
          return Promise.reject(error);
        });
    },
  });

  return {
    createChangeUserPassword,
  };
};

export const useSingleChangeUserPasswordRequest = (requestId?: string) => {
  const requestIdURL = useQueryURL().getQueryValue("requestId");

  const requestIdFound = requestIdURL ? requestIdURL : requestId || "none";
  const { singleQuery } = useSingleGenericAPI<
    ChangePasswordRequest,
    Partial<ChangePasswordRequest>
  >({
    baseURL: BASE_URL_REQUEST_PASSWORD,
    APIname: "getSingleChangeUserPasswordRequest",
    id: requestIdFound,
    disableGet: requestIdFound === "none" || requestIdFound === undefined,
    queryKey: ["getSingleChangeUserPasswordRequest", requestIdFound],
  });

  const changeUserPawssword = useMutation({
    mutationFn: ({
      requestId,
      newPassword,
      callback,
    }: {
      requestId: string;
      newPassword: string;
      callback?: CallbackFunction<boolean, AxiosError>;
    }) => {
      return resetPasswordUserAxios(requestId, newPassword)
        .then((response) => {
          callback && callback({ result: true });
          return Promise.resolve(response);
        })
        .catch((error) => {
          callback && callback({ error: error });
          return Promise.reject(error);
        });
    },
  });

  return {
    getSingleChangeUserPasswordRequest: singleQuery,
    changeUserPawssword,
    requestId: requestIdFound,
  };
};

export default useChangeUserPasswordRequest;
